import { InboxEntryType } from '.';

import { SocketData, SocketPayload } from './SocketData';

export type PermanentlyDeletedSocketData = {
  type: InboxEntryType;
  payload: SocketPayload;
  isSameUser: boolean;
};

export function isPermanentlyDeletedSocketData(
  data: SocketData
): data is PermanentlyDeletedSocketData {
  return (
    typeof data === 'object' &&
    data !== null &&
    data !== undefined &&
    'type' in data &&
    'payload' in data &&
    'isSameUser' in data &&
    data.payload?.deleted === true
  );
}
